import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const OrderConfiguration = ({ exception, handleChange, isStoreCreditEnabled, isGiftCardEnabled }) => {
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Text type="titleS">{t('Configuración del pedido')}</Text>
      <Styles.ConfigurationCheckboxContainer>
        <Checkbox
          checked={exception?.disable_return_fees}
          label={t('Devolución gratuita')}
          onChange={e => handleChange('disable_return_fees', e.target.checked)}
        />
        <Checkbox
          checked={exception?.disable_exchange_fees}
          label={t('Cambio gratuito')}
          onChange={e => handleChange('disable_exchange_fees', e.target.checked)}
        />
        {isStoreCreditEnabled() && (
          <Checkbox
            checked={exception?.only_store_credit}
            label={t('Solo habilitar Crédito en tienda para reembolsos')}
            onChange={e => handleChange('only_store_credit', e.target.checked)}
          />
        )}
        {isGiftCardEnabled() && (
          <Checkbox
            checked={exception?.only_gift_card}
            label={t('Sólo habilitar el método Tarjeta regalo para reembolso')}
            onChange={e => handleChange('only_gift_card', e.target.checked)}
          />
        )}
        <Checkbox
          checked={exception?.refund_shipping_amount}
          label={t('Reembolsar gastos de envío del pedido original')}
          onChange={e => handleChange('refund_shipping_amount', e.target.checked)}
        />
      </Styles.ConfigurationCheckboxContainer>
    </Styles.SectionContainer>
  )
}

OrderConfiguration.propTypes = {
  exception: PropTypes.object,
  handleChange: PropTypes.func,
  isStoreCreditEnabled: PropTypes.func,
  isGiftCardEnabled: PropTypes.func,
}

export default OrderConfiguration
